/**
 * Build-time switches for wake-on-screen, behind functions so each app can supply its own reader.
 *
 * WHY A SEPARATE FILE: the Technician PWA (Vite/Rolldown) inlines every `process.env.X` in shared code
 * to `{}`, so a flag read here would be dead there (the kill switch would do nothing). client-tech's
 * vite.config.ts redirects any import whose text contains 'config/wakeFlags' to its own file that reads
 * `import.meta.env.VITE_*`. Import this module as '../config/wakeFlags' (text containing 'config/'),
 * never './wakeFlags': the redirect matches the import TEXT (see config/__tests__/stubbedImports.test.ts).
 */

/** Global kill switch: REACT_APP_WAKE_KNOCKS=off (office app) / VITE_WAKE_KNOCKS=off (Technician app). */
export const wakeKnocksOff = (): boolean => process.env.REACT_APP_WAKE_KNOCKS === 'off';

/** Emulators are connected: knocks would hit real URLs while the app talks to the emulator. */
export const wakeUsingEmulators = (): boolean =>
  process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true';

/** Raw pilot control-share flag (see parseControlPercent). */
export const wakePilotControlPercentRaw = (): string | undefined => process.env.REACT_APP_WAKE_PILOT_CONTROL_PERCENT;
